import { render, staticRenderFns } from "./RmsSettingsView.vue?vue&type=template&id=2490c622"
import script from "./RmsSettingsView.vue?vue&type=script&lang=js"
export * from "./RmsSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports